import { Box, Button, Icon, Modal, OptimizeImage, Text } from '@inflearn/ds-react-next';
import { useLang } from '@inflearn/i18n-tools';
import { faCircleQuestion } from '@inflearn/pro-regular-svg-icons';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

type MyVoucherGuideModalProps = {
  opened: boolean;
  onClose: () => void;
};

export function MyVoucherGuideModal({ opened, onClose }: MyVoucherGuideModalProps) {
  const { t } = useTranslation();
  const { isKo } = useLang();

  const imgPrefix = useMemo(() => (isKo ? '' : 'en-'), [isKo]);

  return (
    <Modal.Root opened={opened} onClose={onClose} size="lg">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{t('수강 확인증')}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text
            mb="md"
            size="md"
            c="gray.7"
            styles={{
              root: {
                textWrap: 'pretty',
                wordBreak: 'keep-all',
              },
            }}
          >
            {t('강의 보유 여부를 증명하는 문서로')}{' '}
            <Text component="span" fw={700}>
              {t('완강 시 발급되는 수료증과 별개입니다.')}
            </Text>
            <br />
            <Text component="span" fw={700}>
              {t('성명/강의명/수강신청일/발급일이 포함되어 PDF로 발급됩니다.')}
            </Text>
          </Text>
          <Box
            css={{
              img: {
                width: '100%',
                height: 'auto',
              },
            }}
          >
            <OptimizeImage
              w={580 * 1.5}
              alt="Course attendance certificate example"
              src={`${process.env.NEXT_PUBLIC_CDN_URL}/public/files/pages/${imgPrefix}my_voucher_example.png`}
            />
          </Box>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}

export function MyVoucherGuideModalButton() {
  const { t } = useTranslation();
  const [opened, handler] = useDisclosure(false);

  return (
    <>
      <Button
        size="compact-sm"
        radius="md"
        color="gray"
        variant="subtle"
        onClick={handler.open}
        rightSection={<Icon icon={faCircleQuestion} size="sm" color="dark" />}
      >
        {t('수강 확인증')}
      </Button>
      <MyVoucherGuideModal opened={opened} onClose={handler.close} />
    </>
  );
}
